import actions from './actions';

const {
  LIST_ORDERS_BEGIN,
  LIST_ORDERS_SUCCESS,
  LIST_ORDERS_ERR,
  ORDER_DETAILS_BEGIN,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_ERR,
  CREATE_ORDER_BEGIN,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_ERR,
  ORDER_RESELL_BEGIN,
  ORDER_RESELL_SUCCESS,
  ORDER_RESELL_ERR,
  ORDER_DOWNLOAD_BEGIN,
  ORDER_DOWNLOAD_SUCCESS,
  ORDER_DOWNLOAD_ERR,
} = actions;

const initState = {
  loadingListOrders: false,
  errorListOrders: '',
  orders: [],
  loadingOrderDetails: false,
  errorOrderDetails: '',
  orderDetails: {},
  totalOrders: 0,
  totalOrdersPages: 0,
  loadingCreateOrder: false,
  errorCreateOrder: '',
  loadingOrderResell: false,
  errorOrderResell: null,
  loadingOrderDownload: false,
  errorOrderDownload: null,
};

const salesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_ORDERS_BEGIN:
      return {
        ...state,
        loadingListOrders: true,
        errorListOrders: null,
        totalOrders: 0,
        totalOrdersPages: 0,
      };
    case LIST_ORDERS_SUCCESS:
      return {
        ...state,
        orders: [...data.results],
        loadingListOrders: false,
        errorListOrders: null,
        totalOrders: data.total_count,
        totalOrdersPages: data.total_pages,
      };
    case LIST_ORDERS_ERR:
      return {
        ...state,
        errorListOrders: err,
        loadingListOrders: false,
        totalOrders: 0,
        totalOrdersPages: 0,
      };
    case ORDER_DETAILS_BEGIN:
      return {
        ...state,
        loadingOrderDetails: true,
        errorOrderDetails: null,
      };
    case ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        orderDetails: data,
        loadingOrderDetails: false,
        errorOrderDetails: null,
      };
    case ORDER_DETAILS_ERR:
      return {
        ...state,
        errorOrderDetails: err,
        loadingOrderDetails: false,
      };

    case CREATE_ORDER_BEGIN:
      return {
        ...state,
        loadingCreateOrder: true,
        errorCreateOrder: null,
      };
    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loadingCreateOrder: false,
        errorCreateOrder: null,
      };
    case CREATE_ORDER_ERR:
      return {
        ...state,
        errorCreateOrder: err,
        loadingCreateOrder: false,
      };
    case ORDER_RESELL_BEGIN:
      return {
        ...state,
        loadingOrderResell: true,
        errorOrderResell: null,
      };
    case ORDER_RESELL_SUCCESS:
      return {
        ...state,
        loadingOrderResell: false,
        errorOrderResell: null,
      };
    case ORDER_RESELL_ERR:
      return {
        ...state,
        errorOrderResell: err,
        loadingOrderResell: false,
      };
    case ORDER_DOWNLOAD_BEGIN:
      return {
        ...state,
        loadingOrderDownload: true,
        errorOrderDownload: null,
      };
    case ORDER_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loadingOrderDownload: false,
        errorOrderDownload: null,
      };
    case ORDER_DOWNLOAD_ERR:
      return {
        ...state,
        errorOrderDownload: err,
        loadingOrderDownload: false,
      };
    default:
      return state;
  }
};

export { salesReducer };
